export default "__VITE_ASSET__cb2f3665__"